module.exports = __webpack_public_path__ + "img/ten_.46529574.png";